var map = {
	"./views": [
		"1e4b",
		"chunk-2d0b68f8"
	],
	"./views/": [
		"1e4b",
		"chunk-2d0b68f8"
	],
	"./views/auth": [
		"6ecd",
		"chunk-05744bcd"
	],
	"./views/auth.vue": [
		"6ecd",
		"chunk-05744bcd"
	],
	"./views/index": [
		"1e4b",
		"chunk-2d0b68f8"
	],
	"./views/index.vue": [
		"1e4b",
		"chunk-2d0b68f8"
	],
	"./views/login": [
		"dd7b",
		"chunk-0fc5cfd6"
	],
	"./views/login.vue": [
		"dd7b",
		"chunk-0fc5cfd6"
	],
	"./views/orders": [
		"2fbb",
		"chunk-d6ca36aa"
	],
	"./views/orders/": [
		"2fbb",
		"chunk-d6ca36aa"
	],
	"./views/orders/index": [
		"2fbb",
		"chunk-d6ca36aa"
	],
	"./views/orders/index.vue": [
		"2fbb",
		"chunk-d6ca36aa"
	],
	"./views/refundorders": [
		"1b6a",
		"chunk-517051f3"
	],
	"./views/refundorders/": [
		"1b6a",
		"chunk-517051f3"
	],
	"./views/refundorders/index": [
		"1b6a",
		"chunk-517051f3"
	],
	"./views/refundorders/index.vue": [
		"1b6a",
		"chunk-517051f3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a68";
module.exports = webpackAsyncContext;